<template>
  <b-modal v-model="showModal" centered header-class="custom-modal-header" footer-class="custom-modal-footer">
    <template #modal-header>
      <p class="text-header">
        {{ form.id == 0 ? "CREATE" : "UPDATE" }} VARIABLE
      </p>
    </template>
    <b-row>
      <b-col>
        <InputText
          v-model="form.name"
          name="variable.name"
          textFloat="Name"
          placeholder="Name"
          type="text"
          isRequired
          :isValidate="$v.form.name.$error"
          :v="$v.form.name"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <InputSelect
          title="Type"
          name="variable.type"
          isRequired
          v-model="form.type"
          :options="options"
          @onDataChange="handleChange"
          :isValidate="$v.form.type.$error"
          :v="$v.form.type"
          class="mb-0"
        />
      </b-col>
    </b-row>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button :disabled="isLoading" class="cancel-button" @click="hide()">
          Cancel
        </button>
        <button :disabled="isLoading" class="save-button" @click="onSubmit()">
          Save
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ModalCreateOrEdit",
  components: {
    InputText,
    InputSelect
  },
  validations() {
    return {
      form: {
        name: { required },
        type: { required },
      },
    };
  },
  data: function() {
    return {
      showModal: false,
      form: {
        id: 0,
        name: "",
        type: "Number",
      },
      options: [
        { value: 'Number', text: 'Number' },
        { value: 'String', text: 'String' },
      ],
      isLoading: false
    };
  },
  methods: {
    show(item) {
      this.$v.$reset();
      if (item === null) {
        this.form = {
          id: 0,
          name: "",
          type: "Number",
        };
      } else this.form = {...item};
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    handleChange(value) {
      this.form.type = value;
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;
      let path = "update";
      if (this.form.id === 0) path = "create";

      await this.axios
        .post(`${this.$baseUrl}/System/condition/varialble/${path}`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : data.message });
            this.$emit("reloadData");
          }
          else this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message }); 
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : err.message });
        });
      this.isLoading = false;
    },
  },
};
</script>
